import { LazyLoad } from 'app/utils';

export const AdminListPage = LazyLoad(
  () => import('./index'),
  (module) => module.AdminListPage,
);
